import { Box, Typography } from "@mui/material"
import { alpha } from "@mui/material/styles"
import React from "react"
import { capitalize } from "lodash"
import { EventTooltip } from "../styled"
import { formatEventTime, truncateGroupName, truncateName } from "../utils"

/**
 * Renders an event in the month calendar
 */
const CalendarEvent = React.memo(({ event, maxChars, onClick, userTimezone }) => {
  const eventName =
    event.type === "group" ? truncateGroupName(event.title, maxChars) : truncateName(event.title, maxChars)

  const eventStatus = event.status === "cancelled_no_show" ? "No Show" : capitalize(event.status);

  const tooltipTitle = event.type === "group" ? `${event.title} | ${eventStatus}` : `${event.title} | ${eventStatus}`

  return (
    <EventTooltip title={tooltipTitle} placement="top" arrow>
      <Box
        sx={{
          fontSize: "0.75rem",
          cursor: "pointer",
          marginBottom: "2px",
          display: "flex",
          alignItems: "center",
          width: "100%",
          minWidth: 0,
          textAlign: "left",
          padding: "4px 8px",
          borderRadius: "4px",
          transition: "all 0.2s ease",
          "&:hover": {
            backgroundColor: theme => alpha(theme.palette.legend[event.view], 0.2),
            color: "inherit",
            "& .event-dot": {
              backgroundColor: theme => theme.palette.legend[event.view],
            },
            "& .event-text": {
              color: "inherit",
            },
          },
        }}
        onClick={() => onClick(event)}
      >
        <Box
          className="event-dot"
          sx={{
            width: 8,
            height: 8,
            borderRadius: "50%",
            bgcolor: theme => theme.palette.legend[event.view],
            marginRight: "4px",
            flexShrink: 0,
            transition: "all 0.2s ease",
          }}
        />
        <Box
          sx={{
            display: "flex",
            minWidth: 0,
            width: "100%",
            gap: "4px",
          }}
        >
          <Typography
            component="span"
            noWrap
            className="event-text"
            sx={{
              fontSize: "inherit",
              flexShrink: 0,
              transition: "all 0.2s ease",
            }}
          >
            {formatEventTime(event.start, userTimezone)}
          </Typography>
          <Typography
            noWrap
            className="event-text"
            sx={{
              fontSize: "inherit",
              overflow: "hidden",
              textOverflow: "ellipsis",
              transition: "all 0.2s ease",
            }}
          >
            {eventName}
          </Typography>
        </Box>
      </Box>
    </EventTooltip>
  )
})

CalendarEvent.displayName = "CalendarEvent"

export default CalendarEvent
